const QUESTION_ANSWER_SLIDE_COMPONENT = 'QuestionAnswerSlide';
const QUESTION_MULTI_ANSWER_SLIDE_COMPONENT = 'QuestionMultiAnswerSlide';
const QUESTION_SCALE_SLIDE_COMPONENT = 'QuestionScaleSlide';
const START_SLIDE = 'StartSlide';
const PLAN_LOADER_SLIDE = 'PlanLoaderSlide';
const EMAIL_SLIDE = 'EmailSlide';
const PAUSE_SLIDE = 'PauseSlide';
const PRODUCT_SLIDE = 'ProductSlide';
const PLAN_GRAPH_SLIDE = 'PlanGraphSlide';
const REVIEW_SLIDE = 'ReviewSlide';
const RESULT_SLIDE = 'ResultSlide';
const PROFILE_SLIDE = 'ProfileSlide';
const NAME_SLIDE = 'NameSlide';
const PRESALE_SLIDE = 'PreSaleSlide';

export {
    QUESTION_ANSWER_SLIDE_COMPONENT,
    QUESTION_MULTI_ANSWER_SLIDE_COMPONENT,
    QUESTION_SCALE_SLIDE_COMPONENT,
    START_SLIDE,
    PLAN_LOADER_SLIDE,
    EMAIL_SLIDE,
    PAUSE_SLIDE,
    PRODUCT_SLIDE,
    PLAN_GRAPH_SLIDE,
    REVIEW_SLIDE,
    RESULT_SLIDE,
    PROFILE_SLIDE,
    NAME_SLIDE,
    PRESALE_SLIDE
};
